export const machineObjectName = "machine";
export const machineConfigurationObjectName = "machineConfiguration";
export const machineConfigurationTypeObjectName = "machineConfigurationType";
export const machineEpromConfigurationObjectName = "machineEpromConfiguration";
export const machineGameConfigurationObjectName = "machineGameConfiguration";
export const machineManufacturerName = "machineManufacturer";
